/**
 * Утилита для работы с CSRF токенами
 */

let csrfToken = null;

/**
 * Получает CSRF токен с сервера
 */
export const fetchCSRFToken = async () => {
  try {
    const response = await fetch('/api/csrf-token', {
      method: 'GET',
      credentials: 'include' // Важно для работы с cookies
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }
    
    const data = await response.json();
    csrfToken = data.csrfToken;
    return csrfToken;
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    // Возвращаем null, но не выбрасываем ошибку
    // Запрос может все равно работать, если токен есть в cookie
    return null;
  }
};

/**
 * Получает текущий CSRF токен (если уже получен)
 * Если токен не получен, запрашивает его
 */
export const getCSRFToken = async () => {
  if (csrfToken) {
    return csrfToken;
  }
  
  return await fetchCSRFToken();
};

/**
 * Сбрасывает CSRF токен (например, при ошибке 403)
 */
export const resetCSRFToken = () => {
  csrfToken = null;
};

/**
 * Добавляет CSRF токен в заголовки запроса
 */
export const addCSRFTokenToHeaders = async (headers = {}) => {
  const token = await getCSRFToken();
  if (token) {
    headers['X-CSRF-Token'] = token;
  }
  return headers;
};

/**
 * Инициализирует CSRF токен при загрузке приложения
 */
export const initCSRF = async () => {
  try {
    await fetchCSRFToken();
  } catch (error) {
    console.error('Failed to initialize CSRF token:', error);
  }
};
